import React from "react";
import { Result, Spin } from "antd";

const GlobalLoading = () => {
	return <Result icon={<Spin />} title="Loading..." />;
};

export default GlobalLoading;
